import React from 'react';
import { AnimatedSection } from '../components/ui/AnimatedSection';
import { SectionHeading } from '../components/ui/SectionHeading';
import { ArrowRightIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function Blog() {
  const posts = [{
    category: 'Metabolic Health',
    title: 'Understanding Insulin Resistance: The Silent Epidemic',
    excerpt: 'Why your metabolism might already be struggling even if your labs look "normal."',
    date: 'Oct 12, 2025',
    readTime: '6 min read',
    slug: '/insights/insulin-resistance',
    image: 'https://images.unsplash.com/photo-1579684385127-1ef15d508118?q=80&w=1000'
  }, {
    category: 'Strength',
    title: 'Why Strength Training Is the Foundation of Longevity',
    excerpt: 'Muscle is not aesthetic — it is one of the strongest protectors of your health.',
    date: 'Oct 05, 2025',
    readTime: '5 min read',
    slug: '/insights/strength-longevity',
    image: 'https://images.unsplash.com/photo-1534438327276-14e5300c3a48?q=80&w=1000'
  }, {
    category: 'Nutrition',
    title: 'The Metabolic Reset: What Your Blood Work Reveals',
    excerpt: 'Stop guessing. Your body already has answers — if you know how to read them.',
    date: 'Sep 28, 2025',
    readTime: '8 min read',
    slug: '/insights/metabolic-reset',
    image: 'https://images.unsplash.com/photo-1532187863486-abf9dbad1b69?q=80&w=1000'
  }, {
    category: 'Mindset',
    title: 'Mindset and Metabolic Health: The Cortisol Connection',
    excerpt: 'Stress is not just mental — it directly impacts your metabolism.',
    date: 'Sep 15, 2025',
    readTime: '4 min read',
    slug: '/insights/cortisol-connection',
    image: 'https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?q=80&w=1000'
  }, {
    category: 'Faith',
    title: 'Faith, Discipline, and Physical Transformation',
    excerpt: 'True transformation is not physical first — it starts with identity.',
    date: 'Sep 02, 2025',
    readTime: '5 min read',
    slug: '/insights/faith-discipline',
    image: 'https://images.unsplash.com/photo-1447452001602-7090c7ab2db3?q=80&w=1000'
  }, {
    category: 'Science',
    title: 'The Science of Fat Loss: Beyond Calories In, Calories Out',
    excerpt: "Fat loss is not math — it's physiology.",
    date: 'Aug 20, 2025',
    readTime: '7 min read',
    slug: '/insights/fat-loss-science',
    image: 'https://images.unsplash.com/photo-1581009146145-b5ef050c2e1e?q=80&w=1000'
  }];
  return <main className="w-full pt-24" data-id="element-160">
      <section className="py-20 md:py-32 bg-dark" data-id="element-161">
        <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-162">
          <AnimatedSection data-id="element-163">
            <SectionHeading overline="Insights" title="Science-Backed Health & Performance" description="Articles, research, and thoughts on metabolic health, strength training, and longevity." data-id="element-164" />
          </AnimatedSection>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mt-20" data-id="element-165">
            {posts.map((post, i) => <AnimatedSection key={i} delay={i * 0.1} data-id="element-166">
                <Link to={post.slug} className="block group h-full bg-surface border border-border hover:border-gold/50 transition-colors overflow-hidden flex flex-col" data-id="element-167">
                  <div className="relative h-48 overflow-hidden" data-id="element-168">
                    <img src={post.image} alt={post.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" data-id="element-169" />
                    <div className="absolute top-4 left-4 bg-black/80 backdrop-blur-sm text-gold text-xs font-bold uppercase tracking-wider px-3 py-1" data-id="element-170">
                      {post.category}
                    </div>
                  </div>
                  <div className="p-8 flex-1 flex flex-col" data-id="element-171">
                    <h3 className="text-xl font-bold text-white mb-3 font-heading group-hover:text-gold transition-colors" data-id="element-172">
                      {post.title}
                    </h3>
                    <p className="text-muted text-sm leading-relaxed mb-6 flex-1" data-id="element-173">
                      {post.excerpt}
                    </p>
                    <div className="flex items-center justify-between border-t border-border pt-4 mt-auto" data-id="element-174">
                      <div className="text-xs text-muted font-medium" data-id="element-175">
                        {post.date} • {post.readTime}
                      </div>
                      <div className="flex items-center text-sm font-bold text-gold group-hover:text-white transition-colors" data-id="element-176">
                        Read More
                        <ArrowRightIcon className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-177" />
                      </div>
                    </div>
                  </div>
                </Link>
              </AnimatedSection>)}
          </div>
        </div>
      </section>
    </main>;
}